import React, {useEffect} from "react";
import InfoTooltip from "../tooltips/InfoTooltip";
import {useDispatch, useSelector} from "react-redux";
import FeatureField from "../fields/FeatureField";
import FeatureFreeField from "../fields/FeatureFreeField";
import useSelectedFeature from "../../hooks/useSelectedFeature";
import {fetchBalanceInfo} from "../../../account/actions/BalanceActions";
import useSyncedField from "../../hooks/useSyncedField";

function HighPriority() {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);

    useEffect(() => {
        if (user.user) {
            dispatch(fetchBalanceInfo());
        }
    }, []);

    const {balance} = useSelector(state => state.balance);

    const feature = useSelector(state => state.orderOptions.data.features.vipSupport);
    const features = useSelectedFeature();
    let isFreeVipSupport = features && features.some((item) => item.isFreeVipSupport);
    let isVipSupport = features && features.some((item) => item.isVipSupport);

    let item = null;
    if (useSelector(state => state.ordersReducer)) {
        item = useSelector(state => state.ordersReducer.item);
    }

    let isFreeVIPSupportYet = item && item.is_free_vip_support;

    useSyncedField('vipSupport','int');
    useSyncedField('freeVipSupport', 'int');

    return <div className="form-col-2 form-control-high-priority">
        {isFreeVipSupport ? '' :
            <FeatureField
                name="vipSupport"
                feature={feature}
                tooltip={(
            <InfoTooltip>
                <p>
                    We will provide you with a personal VIP manager responsible for 24/7 tracking your order until the final delivery.
                </p>
            </InfoTooltip>
        )}/>}
        {(isFreeVIPSupportYet && !isVipSupport) || (!isVipSupport && balance && balance.vip_count > 0) ?
            <FeatureFreeField
                name="freeVipSupport"
                feature={feature}
                tooltip={(
            <InfoTooltip>
                <p>
                    You can use free "High priority" feature from your balance for this order
                </p>
            </InfoTooltip>
        )}/> : ''}
    </div>
}

export default HighPriority;